import { createContext } from "react";
import { DesignState, Image } from "../../types";

type DesignContextType = {
  designId: string | undefined;
  design: DesignState | undefined;
  isDesignLoading: boolean;
  refetchDesign: (options?: { skipLoading?: boolean }) => Promise<void>;
  clearDesign: () => void;
  updateDesignImages: (images: Image[]) => void;
};

export const DesignContext = createContext<DesignContextType>({
  designId: undefined,
  design: undefined,
  isDesignLoading: false,
  refetchDesign: () => Promise.resolve(),
  clearDesign: () => {},
  updateDesignImages: () => {},
});
